import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinAtmData = createAsyncThunk("api/atm-payroll/atmFinance", async (token) => {
    try {
        const response = await nodeinstance.get("/atm-payroll/atmFinance", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinAtmDataSlice = createSlice({
    name: "boder",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinAtmData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinAtmData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinAtmData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinAtmData };
export default FinAtmDataSlice.reducer;
